import { React, useState, useEffect, useRef } from "react";
import DataTable from "../../../../Components/UiComponents/DataTable";
// Import Services
import {
  getCustomerFields,
  getExternalUsersName,
} from "../../../../Services/fieldsServices";
import { getCustomerFields2 } from "../../../../Services/fieldsServices";
import { getExternalUsers } from "../../../../Services/fieldsServices";
import { getCustomerControlField } from "../../../../Services/customerServices";
import {
  addsurveydata,
  checkEmail,
  getTable,
  removeSavedTemplate,
  saveEmail,
  saveSurveyLogs,
} from "../../../../Services/tooltipService";
import { getOpportunity } from "../../../../Services/tooltipService";
import { getClient } from "../../../../Services/tooltipService";
import { getField } from "../../../../Services/tooltipService";
import { getSurveyTemplate } from "../../../../Services/tooltipService";
import { getSavedTemplate } from "../../../../Services/tooltipService";
import { updateSurveyTemplate } from "../../../../Services/tooltipService";
import { saveTemplate } from "../../../../Services/tooltipService";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { getSurveyConfig } from "../../../../Services/surveyData";
import _ from "lodash";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import { InputIcon } from "primereact/inputicon";
import InputTextElement from "../../../../Components/UiComponents/InputTextElement";
import AutoCompleteElement from "../../../../Components/UiComponents/AutoCompleteElement";
import { Dialog } from "primereact/dialog";
import MultiSelectElement from "../../../../Components/UiComponents/MultiSelectElement";
import SingleSelectElement from "../../../../Components/UiComponents/SingleSelectElement";
import RadioElement from "../../../../Components/UiComponents/RadioElement";
import TextareaElement from "../../../../Components/UiComponents/TextareaElement";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import { useForm, Controller } from "react-hook-form";
import { get, getuserbyid } from "../../../../Services/userService";
import { getCustomer } from "../../../../Services/customerServices";
import Loader from "../../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import SelectButtonElement from "../../../../Components/UiComponents/SelectButtonElement";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

export default function DataCollectionConfig(props) {
  const [customerId, setCustomerId] = useState(null);
  const [costmerReferenceData, setCostmerReferenceData] = useState([]);
  const [customerField, setCustomerField] = useState([]);
  const [getCusOpportunity, setCusOpportunity] = useState(null);
  const [clientList, setClientList] = useState(null);
  const [extUsers, setExtUsers] = useState(null);
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const [dialogError, setDialogError] = useState({});
  const [surveyConfigForm, setSurveyConfigForm] = useState({
    external_user_name: "",
    external_email: "",
    clientList: [],
    projectList: [],
  });
  const [formData, setFormData] = useState({
    external_user_name: "",
    external_email: "",
  });
  const [addExtraEmailPopUp, setAddExtraEmailPopUp] = useState(false);
  const [addPipeLineFieldPopUp, setAddPipeLineFieldPopUp] = useState(false);
  // React forms
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
    getValues,
    trigger,
  } = useForm(); //surveyConfigForm
  const {
    register: registerSurveyAddForm,
    handleSubmit: handleSubmitSurveyAddForm,
    formState: { errors: errorsSurveyAddForm },
    reset: resetSurveyAddForm,
    setValue: setValueSurveyAddForm,
    setError: setErrorSurveyAddForm,
    getValues: getValuesSurveyAddForm,
    trigger: triggerSurveyAddForm,
  } = useForm(); //surveyAddForm surveyConfig
  // States variables
  const [emailFlag, setEmailFlag] = useState(null);
  const [surveyFormDatas, setSurveyFormDatas] = useState({
    users: { external_email: "" },
  });
  const [commanFieldsNew, setCommanFieldsNew] = useState([]);
  const [commonPipeArray, setCommonPipeArray] = useState([]);
  const [subModuleList, setSubModuleList] = useState([]);
  const [subModuleListDisplay, setSubModuleListDisplay] = useState([]);
  const [surveyFormData, setSurveyFormData] = useState({
    opportunityListSurvey: [],
    clientListSurvey: [],
    remainderUser: [],
    isRemainder: "",
  });
  const [action, setAction] = useState(false);
  const [checkedListArray, setCheckedListArray] = useState([]);
  const [subModuleId, setSubModuleId] = useState();
  const [surveyTemplateData, setSurveyTemplateData] = useState();
  const [surveyConfig, setSurveyConfig] = useState({});
  const [loader, setLoader] = useState();
  const [tmpField, setTmpField] = useState([]);
  const [tmpFieldOpts, setTmpFieldOpts] = useState([]);
  const [tempShow, setTempShow] = useState(false);
  const [updatedTmpField, setUpdatedSurveyTemplateField] = useState();
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [viewSurveyFields, setViewSurveyFields] = useState(null);
  const [templateNameView, setTemplateNameView] = useState("");
  const [viewSurveyTemplateModal, setViewSurveyTemplateModal] = useState(false);
  const [editTemplateId, setEditTemplateId] = useState(null);
  const [templateName, setTemplateName] = useState("");
  const [editSurveyTemplateModal, setEditSurveyTemplateModal] = useState(false);
  const [surveyTemplateModal, setSurveyTemplateModal] = useState(false);
  const [isCopy, setIsCopy] = useState(false);
  const [showConfirmPrompt, setShowConfirmPrompt] = useState(false);
  const [showConfirmPromptForTemplate, setShowConfirmPromptForTemplate] =
    useState(false);
  const [removeTemplateId, setRemoveTemplateId] = useState(null);
  const [removeTemplateName, setRemoveTemplateName] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [publishsurveyPopup, setPublishsurveyPopup] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [useTempId, setUseTempId] = useState();
  const [useTemp, setUseTemp] = useState(false);
  const [pipModuleData, setPipModuleData] = useState();
  const [showVideo, setShowVideo] = useState(false);

  // Display name
  const [contlPannelWinplan, setContlPannelWinplan] = useState("");
  const [Customer, setCustomer] = useState(null);

  const toastRef = useRef();
  const childRef = useRef();
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          getCustomerField(),
          getCustomerControlFieldFun(),
          getOpportunityList(),
          getClientList(),
          getExtUsers(),
          getCustomerTable(),
          pipelineModuleData()
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false)
      } 
    }

    fetchData();
  }, [customerId]);

  useEffect(() => {
    // Increment the tableKey to force a re-render of the DataTable
    setTableKey((prevKey) => prevKey + 1);
  }, [checkedListArray]);

  useEffect(() => {
    if (!_.isEmpty(subModuleList)) {
      const updatedSubModules = subModuleList.map((sm) => {
        const updatedFields = sm.fields.map((s) => {
          return {
            ...s,
            template_checked: false,
            field_required: false,
          };
        });
        return {
          ...sm,
          fields: updatedFields,
        };
      });
      setSubModuleList(updatedSubModules);
      const transformedSubModules = updatedSubModules.map((item) => ({
        label: item.display_name,
        value: item._id,
      }));
      // To show as option
      setSubModuleListDisplay(transformedSubModules);
      const updatedCommonPipeArray = commonPipeArray.map((s) => {
        return {
          ...s,
          template_checked: false,
          field_required: false,
        };
      });
      setCommonPipeArray(updatedCommonPipeArray);
    }
  }, []);

  useEffect(() => {
    const enduserStr = localStorage.getItem("enduser");
    if (enduserStr) {
      const enduser = JSON.parse(enduserStr);
      const customer = enduser.customer;
      setCustomer(enduser);
      setCustomerId(customer);
    } else {
      navigate("/login")
      localStorage.clear()
    }
  }, []);

  useEffect(() => {
    if (customerId) {
      getRdsData(customerId)
    }
  }, [customerId])

  const getRdsData = async (id) => {
    try {
      const customerData = await getCustomer(id);
      if (customerData) {
        setPreviewData(customerData.data.rds_data);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  // Function to call the child component's function
  const handleClick = () => {
    if (selectedRowData.length > 0) {
      let newArray = checkedListArray.filter(
        (obj1) =>
          !selectedRowData.some(
            (obj2) => obj1.sub_module.fields.id === obj2.sub_module.fields.id
          )
      );
      setCheckedListArray(newArray);
    }
  };

  // Get API Methods
  const getExtUsers = async function () {
    try {
      if (customerId === null) {
        return;
      }
      // setLoading(true)
      if (customerId !== null) {
        const extUsers = await getExternalUsers(customerId);
        const extUsersEmail = extUsers?.data?.users?.map((item) => ({
          external_email: item?.external_email,
        }));
        setExtUsers(extUsersEmail);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      //setLoading(false)
    }
  };

  const getCustomerField = async function () {
    try {
      if (customerId === null) {
        return;
      }
      // setLoading(true)
      if (customerId !== null) {
        const customerData = await getCustomerFields(customerId); // Reference
        setCostmerReferenceData(customerData?.data?.reference_data);

        const customerData1 = await getCustomerFields2(customerId);
        setCustomerField(customerData1?.data?.cust[0]);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      //setLoading(false)
    }
  };

  const getCustomerControlFieldFun = async function () {
    try {
      if (customerId === null) {
        return;
      }
      // setLoading(true)
      if (customerId !== null) {
        const customerData = await getCustomerControlField(customerId);
        setCustomerControlFields(customerData?.data?.cust[0].modules[0].tabs[18]);
        setContlPannelWinplan(
          customerData.data?.cust[0].modules[0].tabs[22]?.display_name
        );
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      //setLoading(false)
    }
  };

  const getOpportunityList = async function () {
    try {
      if (customerId === null) {
        return;
      }
      // setLoading(true)
      if (customerId !== null) {
        const customerOpp = await getOpportunity(customerId);
        const opportunityList = customerOpp?.data?.opportunity?.map((item) => ({
          id: item._id,
          label: item.opportunity_name,
          // bid_user_list: item.ie_bid_team
        }));
        setCusOpportunity(opportunityList);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      //setLoading(false)
    }
  };

  const getClientList = async function () {
    try {
      if (customerId === null) {
        return;
      }
      // setLoading(true)
      if (customerId !== null) {
        const customerOpp = await getClient(customerId);
        const clientList = customerOpp?.data?.client?.map((item) => ({
          id: item._id,
          label: item.client_name,
        }));
        setClientList(clientList);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      //setLoading(false)
    }
  };

  const getCustomerTable = async function () {
    try {
      if (customerId === null) {
        return;
      }
      if (customerId !== null) {
        const customerTable = await getTable(customerId);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  const pipelineModuleData = async () => {
    try {
      // setLoading(true)
      const response = await getField(customerId);
      setPipModuleData(response?.data);
      fieldConfigData();
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      //setLoading(false)
    }
  };


  // Field config data
  const fieldConfigData = async () => {
    try {
      if (customerId === null) {
        return;
      }
      // setLoading(true)
      if (customerId !== null) {
        const data = await getSurveyConfig(customerId);
        const customerData = data?.data;

        let projectModulesDyn = [];
        let pipeNewFields = [];

        const moduleIndex = _.findIndex(
          pipModuleData?.cust[0].modules,
          { module_name: "Clients" },
          true
        );

        projectModulesDyn = _.find(
          pipModuleData?.cust[0].modules,
          { module_name: "Clients" },
          true
        );

        const subIndex = _.findIndex(projectModulesDyn?.sub_modules, {
          sub_module_name: "Relationship Development Score",
        });

        pipeNewFields = _.find(projectModulesDyn?.sub_modules, {
          sub_module_name: "Relationship Development Score",
        })?.fields;

        // Function to compare based on the property
        function compareById(item1, item2) {
          return item1.reference_key === item2.option_name;
        }

        // Use filter to compare and get elements from array1
        const result = pipeNewFields?.filter((item1) =>
          customerData?.rds_data?.some((item2) => compareById(item1, item2))
        );
        if (pipModuleData) {
          const updatedModules = [...pipModuleData.cust];
          updatedModules[0].modules[moduleIndex].sub_modules[subIndex].fields =
            result;
          setPipModuleData({
            ...pipModuleData,
            cust: updatedModules,
          });
        }

        allModulesData(); // Call the function to update all modules data
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      //setLoading(false)
    }
  };


  // add email
  const addsurveyEmail = (emailFlag, emailValue) => {
    setEmailFlag(emailFlag);
    setSurveyFormDatas((prevData) => ({
      ...prevData,
      users: {
        ...prevData.users,
        external_email: emailValue,
      },
    }));
  };




  // All modules data

  const allModulesData = () => {
    const projectModulesDyn = _.find(
      pipModuleData?.cust[0].modules,
      { module_name: "Pipeline" },
      true
    );
    const clientModulesDyn = _.find(
      pipModuleData?.cust[0].modules,
      { module_name: "Clients" },
      true
    );
    const commonFields = _.find(
      pipModuleData?.cust[0].modules,
      { module_name: "Common Fields" },
      true
    );
    const commanModules = _.find(
      pipModuleData?.cust[0].modules,
      { module_name: "Common Fields" },
      true
    );
    const commanFieldsNewTemp = _.find(commanModules?.sub_modules, {
      sub_module_name: "Common Fields",
    })?.fields;

    setCommanFieldsNew(commanFieldsNewTemp);

    const pipeAdditionalFields = [
      { field_name: "Sector" },
      { field_name: "Business Unit" },
      { field_name: "Region" },
      { field_name: "Services" },
      { field_name: "Work Classification" },
    ];

    const commonPipeArrayTemp = [];
    pipeAdditionalFields.forEach((field) => {
      commanFieldsNewTemp?.forEach((element) => {
        if (element.field_name === field.field_name) {
          commonPipeArrayTemp.push({
            field_status: element.field_status,
            field_type: element.field_type,
            reference_key: element.reference_key,
            _id: element._id,
            field_index: element.field_index,
            field_name: element.field_name,
            display_name: element.display_name,
          });
        }
      });
    });

    setCommonPipeArray(commonPipeArrayTemp);
  };

  // Function to clear the survey editing state
  const clearEditSurvey = () => {
    setCheckedListArray([]);
    setDefaults();
    setAction(false);
  };

  // Survey toggel method
  const clearEditSurveyToggle = (moduleName) => {
    setUseTempId("");
    setCheckedListArray([]);
    setAction(false);
    setSurveyFormData({
      opportunityListSurvey: [],
      clientListSurvey: [],
    });

    if (moduleName === "Project") {
      const projectModulesDyn = _.find(
        pipModuleData?.cust[0].modules,
        { module_name: "Pipeline" },
        true
      );
      const subModules = projectModulesDyn.sub_modules;
      setSubModuleList(subModules);
      const transformedSubModules = subModules.map((item) => ({
        label: item.display_name,
        value: item._id,
      }));
      setSubModuleListDisplay(transformedSubModules);
      setSubModuleId(subModules[0]._id);
      getFieldData(subModules, subModules[0]._id);
    }

    if (moduleName === "Client") {
      const clientModulesDyn = _.find(
        pipModuleData?.cust[0].modules,
        { module_name: "Clients" },
        true
      );
      const subModules = clientModulesDyn.sub_modules;
      setSubModuleList(subModules);
      const transformedSubModules = subModules.map((item) => ({
        label: item.display_name,
        value: item._id,
      }));
      setSubModuleListDisplay(transformedSubModules);
      setSubModuleId(subModules[0]._id);
      getFieldData(subModules, subModules[0]._id);
    }

    getSurveyTemplateFun();
  };

  const getSurveyTemplateFun = () => {
    getSurveyTemplate(customerId, getValues("isProClient")).then((response) => {
      setLoader(false);
      setSurveyTemplateData(response.data.surveyTemplateData);
    });
  };

  function stringToBoolean(string) {
    return string?.toLowerCase() === "true";
  }

  // Function to get field data based on subModuleId
  const getFieldData = async (subModuleId) => {
    setSelectedEntity(null);
    let tmpFields = [];
    var foundSubModule;
    if (typeof subModuleId == "object") {
      foundSubModule = _.find(subModuleId, { _id: subModuleId[0]._id });
    } else {
      foundSubModule = _.find(subModuleList, { _id: subModuleId });
    }
    if (foundSubModule) {
      if (foundSubModule.display_name == "ESG Preview Score" || foundSubModule.display_name == "GRI Compliance" || foundSubModule.display_name == "ESG Project") {
        var newData = []
        var count = 0
        for (var i = 0; i < previewData.length; i++) {
          var d = {}
          d.ESG_field_name = previewData[i].display_name
          d.data_Config_field = stringToBoolean(previewData[i].option_status)
          d.display_name = previewData[i].display_name
          d.field_index = i
          d.field_name = previewData[i].display_name
          d.field_status = stringToBoolean(previewData[i].option_status)
          d.field_type = previewData[i].type
          d.flag_status = previewData[i].flag_status
          d.group = previewData[i].group
          d.reference_key = previewData[i].option_name
          d.option_choice = previewData[i].option_choice
          d._id = previewData[i]._id
          newData.push(d)
        }
        foundSubModule.fields = newData
      }
      const tempFieldOpt = foundSubModule.fields;
      setTmpFieldOpts(tempFieldOpt);
      if (action || tempShow) {
        if (tempFieldOpt.length) {
          tmpFields = tempFieldOpt.filter(
            (element) =>
              element.field_type !== "label" &&
              element.field_name !== "Goal" &&
              element.field_name !== "winPlan Section" &&
              element.field_name !== "Risk Type" &&
              element.field_name !== "Bid Status"
          );
        }

        if (tempFieldOpt.length) {
          if (foundSubModule.sub_module_name === "NEW") {
            tmpFields = tempFieldOpt.concat(commonPipeArray);
          } else if (foundSubModule.sub_module_name === "Summary") {
            tmpFields = tempFieldOpt.filter(
              (element) => element.field_name !== "Bid Cost to Date as % of TCV"
            );
          } else {
            tmpFields = tempFieldOpt;
          }
        }

        tmpFields = tmpFields.map((field) => {
          const checkedField = checkedListArray?.find(
            (checkedItem) => [field?.field_key, field?.ESG_field_name, field?.field_name].includes(checkedItem.sub_module.fields.label)
          );
          if (checkedField) {
            field.template_checked = true;
            field.field_required =
              checkedField.sub_module.fields.validation.message === "Yes";
          } else {
            if (field?.template_checked){
              field.template_checked = false;
            }
          }
          return field;
        });
      } else {
        if (tempFieldOpt.length) {
          tmpFields = tempFieldOpt.filter(
            (element) =>
              element.field_type !== "label" &&
              element.field_name !== "Goal" &&
              element.field_name !== "winPlan Section" &&
              element.field_name !== "Risk Type" &&
              element.field_name !== "Bid Status"
          );

          if (foundSubModule.sub_module_name === "NEW") {
            tmpFields = tempFieldOpt.concat(commonPipeArray);
          } else if (foundSubModule.sub_module_name === "Summary") {
            tmpFields = tempFieldOpt.filter(
              (element) => element.field_name !== "Bid Cost to Date as % of TCV"
            );
          } else {
            tmpFields = tempFieldOpt;
          }
        }
      }
    }
    tmpFields = _.filter(tmpFields, { data_Config_field: true });
    setTmpField(tmpFields);
  };
  // Regex for email validation
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  // Handlers methods
  const handleInputChange = (name, value) => {

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "external_user_name") {
      if (value.length < 2) {
        setDialogError({ ...dialogError, [name]: 'Please enter valid username' });
      } else {
        setDialogError({ ...dialogError, [name]: '' });
      }
    }

    // Validation for external_email (pattern and minLength 2)
    if (name === "external_email") {
      if (value.length < 2) {
        setDialogError({ ...dialogError, [name]: 'Please enter valid email id' });
      } else if (!emailPattern.test(value)) {
        setDialogError({ ...dialogError, [name]: 'Please enter valid email id' });
      } else {
        setDialogError({ ...dialogError, [name]: '' }); // Clear error if valid
      }
    }
  };

  const handleSurveyConfigForm = (event) => {
    if (event == "Yes" || event == "No") {
      var id = "remaindar";
      var value = event;
    } else {
      var id = event.target.id;
      var value = event.target.value;
    }
    setSurveyConfigForm({
      ...surveyConfigForm,
      [id]: value,
    });
    const newFormData = surveyConfigForm;
  };
  const handleUserEmailConfigForm = (event) => {
    const id = event.target.id;
    const value = event.value;
    setSurveyConfigForm({
      ...surveyConfigForm,
      [id]: value,
    });
    const newFormData = surveyConfigForm;
  };

  const onSurveyFormSubmit = (data) => {
    console.log("data");
  };

  const handleSubmitExternalEmail = async (e) => {
    e.preventDefault();
    try {
      if (dialogError.external_user_name !== "" || dialogError.external_email !== "") {
        return;
      }
      else {
        const emailResponse = await checkEmail(customerId, formData);
        const emailDataFromResponse = emailResponse?.data?.surveyEmailData;
        const emailCheck = _.find(emailDataFromResponse, { customer_id: emailResponse?.data?.cus_id, external_email: formData.external_email });
        if (formData.external_user_name === "" || formData.external_user_name === undefined) {
          toastRef.current.showToast({
            type: 'error',
            message: "Please enter username"
          })
        } else {
          if (formData.external_email === "" || formData.external_email === undefined) {
            toastRef.current.showToast({
              type: 'error',
              message: "Please enter valid email id"
            })
          } else {
            if (_.isEmpty(emailCheck)) {
              const saveResponse = await saveEmail(customerId, formData);
              if (saveResponse && saveResponse.data.success) {
                setFormData({});
                setDialogError({
                  external_email: "",
                  external_user_name: ""

                })
                toastRef.current.showToast({
                  type: 'success',
                  message: saveResponse.data.message
                })
                getExtUsers();
              } else {
                toastRef.current.showToast({
                  type: 'error',
                  message: saveResponse.data.message
                })
              }
              setAddExtraEmailPopUp(false);
            } else {
              toastRef.current.showToast({
                type: 'error',
                message: "Email id already exists"
              })
            }
          }
        }
      }

    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: "Failed to create field"
      });
    }
  };

  const columns = [
    {
      field: "display_name", // Field name for the column data
      header: "Field Name", // Header text displayed in the table header
      //   body: checkingDisplayName, // Function to render the cell content for this column
      style: { width: "30%", fontSize: "12px" }, // CSS styles for the column
    },
    {
      field: "prompt_type",
      header: "Prompt Type",
      //   body: promptType,
      style: { width: "20%", fontSize: "12px" },
    },
    {
      field: "work_stage",
      header: "Field Type",
      //   body: workStage,
      style: { fontSize: "12px", width: "20%" },
    },
    {
      field: "url",
      header: "	Tabs",
      //   body: url,
      style: { fontSize: "12px" },
    },
    {
      field: "url",
      header: "Mandatory",
      //   body: url,
      style: { fontSize: "12px" },
    },
  ];

const getSelectedField = (entity, subModuleId) => {
    let tmpFieldOpts;

    const actualSubModuleId = subModuleId || entity.sub_module_id || entity.subModuleId;

    if (
        entity.field_name === "Sector" ||
        entity.field_name === "Business Unit" ||
        entity.field_name === "Region" ||
        entity.field_name === "Services" ||
        entity.field_name === "Work Classification"
    ) {
        tmpFieldOpts = "Common Fields";
    } else {
        const subModule = subModuleList.find(
            (subModule) => subModule._id === actualSubModuleId
        );
        tmpFieldOpts = subModule ? subModule.display_name : "Unknown Module";
    }

    if (!entity.template_checked) {
        // Handle deselection
        let updatedTmpField = tmpField.map((element) => {
            if (element._id === entity._id) {
                element.field_required = false;
            }
            return element;
        });
        updatedTmpField = _.filter(updatedTmpField, { data_Config_field: true });
        setTmpField(updatedTmpField);

        // Remove from checkedListArray
        const updatedCheckedListArray = checkedListArray.filter(
            (element) => element.sub_module.fields.id !== entity._id
        );
        setCheckedListArray(updatedCheckedListArray);
    } else {
        // Handle selection
        entity.validation = entity.field_required ? "Yes" : "No";
        entity.reference_key = entity.reference_key || "";
        entity.field_key = entity.field_key || "";

        const newElement = {
            sub_module: {
                sub_module_id: actualSubModuleId,
                sub_module_name: tmpFieldOpts,
                fields: {
                    id: entity._id,
                    label: entity.display_name || entity.field_name, 
                    field_key: entity.field_name,
                    type: entity.field_type,
                    field_index: entity.field_index,
                    field_status: entity.field_status,
                    flag_status: entity?.flag_status && entity.flag_status !== "false" ? true : false,
                    option_choice: entity?.option_choice,
                    reference_key: entity.reference_key,
                    template_checked: entity.template_checked,
                    validation: { message: entity.validation },
                    display_name: entity.display_name || entity.field_name,
                    field_name: entity.field_name,
                },
            },
        };

        setCheckedListArray((prevArray) => {
            const exists = prevArray.some(
                (element) => element.sub_module.fields.id === entity._id
            );
            if (!exists) {
                return [...prevArray, newElement];
            } else {
                return prevArray.map((element) =>
                    element.sub_module.fields.id === entity._id ? newElement : element
                );
            }
        });
    }
};

const removeSurveyTemplateField = async (selectedIndex, selectedItems) => {
    
    // Update the tmpField array to reflect the selection changes
    const updatedTmpField = tmpField.map(item => ({
        ...item,
        template_checked: selectedItems.some(selected => 
            selected._id === item._id || selected.field_index === item.field_index
        )
    }));
    
    setTmpField(updatedTmpField);
    setSelectedEntity(selectedIndex);
    
    // Handle deselect all case
    if (selectedItems.length === 0) {
        // Process all deselected items
        tmpField.forEach(item => {
            if (item.template_checked) {
                getSelectedField({ ...item, template_checked: false }, subModuleId);
            }
        });
        return;
    }
    
    // Handle selection changes
    selectedItems.forEach(item => {
        if (item) {
            const itemSubModuleId = subModuleId || item.sub_module_id || item.subModuleId;
            getSelectedField({ ...item, template_checked: true }, itemSubModuleId);
        }
    });
    
    // Process deselected items
    const deselectedItems = tmpField.filter(item => 
        item.template_checked && !selectedItems.some(selected => 
            selected._id === item._id || selected.field_index === item.field_index
        )
    );
    
    deselectedItems.forEach(item => {
        const itemSubModuleId = subModuleId || item.sub_module_id || item.subModuleId;
        getSelectedField({ ...item, template_checked: false }, itemSubModuleId);
    });
    
    setTableKey(prev => prev + 1);
};

  const updateValidation = (fieldID, isRequired) => {
    const updatedList = checkedListArray.map((element) => {
      if (element.sub_module.fields.id === fieldID) {
        element.sub_module.fields.validation.message = isRequired
          ? "Yes"
          : "No";
      }
      return element;
    });

    setCheckedListArray(updatedList);
  };

  const displayMandatory = (rowData) => {
    return (
      <div className="flex" style={{ gap: "8px" }}>
        {getValues("isProClient") === "Project" &&
          rowData.field_type !== "table" &&
          rowData.field_type !== "Table" && (
            <CheckboxElement
              onChangeCheck={(e) => {
                setTmpField((prevState) =>
                  prevState.map((item) =>
                    item._id === rowData._id
                      ? { ...item, field_required: e.target.checked }
                      : item
                  )
                );
                updateValidation(rowData._id, e.target.checked);
              }}
              value={rowData.field_required}
              checked={checkedListArray.some((item) => item._id == rowData._id) || rowData?.field_required === true}
              disabled={!rowData.template_checked}
            />
          )}
        {getValues("isProClient") === "Project" &&
          (rowData.field_type === "table" ||
            rowData.field_type === "Table") && (
            <CheckboxElement
              onChangeCheck={(e) =>
                updateValidation(rowData._id, rowData.field_required)
              }
              value={rowData.template_checked}
              disabled
            />
          )}
        {getValues("isProClient") === "Client" &&
          rowData.field_type !== "widget" &&
          rowData.field_type !== "table" && (
            <CheckboxElement
              onChangeCheck={(e) => {
                setTmpField((prevState) =>
                  prevState.map((item) =>
                    item._id === rowData._id
                      ? { ...item, field_required: e.target.checked }
                      : item
                  )
                );
                updateValidation(rowData._id, e.target.checked);
              }}
              value={rowData.template_checked}
              disabled={!rowData.template_checked}
            />
          )}
        {getValues("isProClient") === "Client" &&
          (rowData.field_type === "widget" ||
            rowData.field_type === "table") && (
            <CheckboxElement
              onChangeCheck={(e) =>
                updateValidation(rowData._id, rowData.field_required)
              }
              value={rowData.template_checked}
              disabled
            />
          )}
      </div>
    );
  };

  const templatesFieldsColumns = [
    // Column configuration for the "Question" field
    {
      field: customerControlFields?.tables[0]?.headers[0]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[0]?.header_name, // Header label for the column
      body: (rowData) => {
        return rowData.data_Config_field ? rowData.display_name : null;
      }, // Custom renderer for the cell content
      style: { width: "40%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    // Column configuration for the "Field" field
    {
      field: customerControlFields?.tables[0]?.headers[1]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[1]?.header_name, // Header label for the column
      body: (rowData) => rowData.field_type, // Custom renderer for the cell content
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    // Column configuration for the "Referred" field
    {
      field: customerControlFields?.tables[0]?.headers[3]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[3]?.header_name, // Header label for the column
      body: displayMandatory, // Custom renderer for the cell content
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const displayTemplateAction = (rowData) => {
    return (
      <div>
        {
          <div className="flex">
            <InputIcon
              className="pi pi-eye ml-0"
              onClick={() => viewSurveyTemplate(rowData, surveyTemplateData)}
            />
            <InputIcon
              className="pi pi-file-edit"
              onClick={() =>
                editSurveyTemplate(
                  true,
                  rowData,
                  rowData.template_name,
                  surveyTemplateData,
                  subModuleId
                )
              }
            />
            <InputIcon
              className="pi pi-copy"
              onClick={() =>
                openSaveTemplate(true, rowData._id, rowData.template_name)
              }
            />
            <InputIcon
              className="pi pi-trash"
              onClick={() => removeTemplate(rowData._id, rowData.template_name)}
            />
          </div>
        }
      </div>
    );
  };

  const viewSurveyTemplate = async (field, surveyTemplate) => {
    try {
      setLoading(true)
      const response = await getSavedTemplate(customerId, field._id);
      const data = response?.data;
      setViewSurveyFields(data.savedTemplateData[0].sub_module);
      setTemplateNameView(data.savedTemplateData[0].template_name);
      setViewSurveyTemplateModal(true);
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const pipelineFieldsColumns = [
    // Column configuration for the "Question" field
    {
      field: customerControlFields?.tables[0]?.headers[0]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[0]?.header_name, // Header label for the column
      body: (rowData) => rowData?.sub_module?.fields?.label, // Custom renderer for the cell content
      style: { width: "40%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    // Column configuration for the "Field" field
    {
      field: customerControlFields?.tables[0]?.headers[1]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[1]?.header_name, // Header label for the column
      body: (rowData) => rowData?.sub_module?.fields?.type, // Custom renderer for the cell content
      style: { width: "20%" },
      headerClassName: "header-datatable",
      className: "row-datatable",
    },

    // Column configuration for the "Referred" field
    {
      field: customerControlFields?.tables[0]?.headers[2]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[2]?.header_name, // Header label for the column
      body: (rowData) => rowData?.sub_module?.sub_module_name, // Custom renderer for the cell content
      headerClassName: "header-datatable",
      className: "row-datatable",
    },

    // Column configuration for the "Referred" field
    {
      field: customerControlFields?.tables[0]?.headers[3]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[3]?.header_name, // Header label for the column
      body: (rowData) => rowData?.sub_module?.fields?.validation?.message, // Custom renderer for the cell content
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const viewSurveyFieldsColumns = [
    // Column configuration for the "Question" field
    {
      field: customerControlFields?.tables[0]?.headers[0]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[0]?.header_name, // Header label for the column
      body: (rowData) => rowData.fields.label, // Custom renderer for the cell content
      style: { width: "40%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    // Column configuration for the "Field" field
    {
      field: customerControlFields?.tables[0]?.headers[1]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[1]?.header_name, // Header label for the column
      body: (rowData) => rowData.fields.type, // Custom renderer for the cell content
      style: { width: "20%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },

    // Column configuration for the "Referred" field
    {
      field: customerControlFields?.tables[0]?.headers[2]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[2]?.header_name, // Header label for the column
      body: (rowData) => rowData.sub_module_name, // Custom renderer for the cell content
      headerClassName: "header-datatable",
      className: "row-datatable",
    },

    // Column configuration for the "Referred" field
    {
      field: customerControlFields?.tables[0]?.headers[3]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[3]?.header_name, // Header label for the column
      body: (rowData) => rowData.fields.validation.message, // Custom renderer for the cell content
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  const surveyTemplateDataFieldsColumns = [
    // Column configuration for the "Question" field
    {
      field: customerControlFields?.tables[0]?.headers[4]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[4]?.header_name, // Header label for the column
      body: (rowData) => rowData.template_name, // Custom renderer for the cell content
      style: { width: "40%" }, // Inline style for the column
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
    // Column configuration for the "Field" field
    {
      field: customerControlFields?.tables[0]?.headers[5]?.display_name, // Data field to map from the row data
      header: customerControlFields?.tables[0]?.headers[5]?.header_name, // Header label for the column
      body: displayTemplateAction, // Custom renderer for the cell content
      headerClassName: "header-datatable",
      className: "row-datatable",
    },
  ];

  // Edit

  const editSurveyTemplate = async (
    editFlag,
    field,
    tempName,
    surveyTemplateData,
    subModuleId
  ) => {
    setAction(true);

    setSelectedEntity(null);
    setEditTemplateId(field._id);
    setTemplateName(tempName);

    // Updating checklist array
    try {
      setLoading(true)
      const response = await getSavedTemplate(customerId, field._id); // Replace with your actual API endpoint
      const data = response?.data;

      const updatedCheckedListArray = data.savedTemplateData[0].sub_module.map(
        (element) => {
          return {
            sub_module: {
              sub_module_name: element.sub_module_name,
              sub_module_id: subModuleId,
              fields: {
                id: element.fields.id,
                label: element.fields.label,
                type: element.fields.type,
                field_index: element.fields.index,
                field_status: element.fields.status,
                template_checked: element.fields.checked,
                reference_key: element.fields.reference_key,
                field_key: element.fields.field_key,
                validation: {
                  message: element.fields.validation.message,
                },
              },
            },
          };
        }
      );
      const newTmpFields = tmpField?.map((field) => {
        const checkedField = updatedCheckedListArray?.find(
          (checkedItem) => [field?.field_key, field?.ESG_field_name, field?.field_name].includes(checkedItem.sub_module.fields.label)
        );
        if (checkedField) {
          field.template_checked = true;
          field.field_required = 
            checkedField.sub_module.fields.validation.message === "Yes";
        } else {
          if(field?.template_checked){
            field.template_checked = false;
          }
        }
        return field;
      });
      setTmpField(newTmpFields)
      setCheckedListArray(updatedCheckedListArray);
      setDefaults();
      setEditSurveyTemplateModal(true)
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const setDefaults = () => {
    const updatedSubModuleList = subModuleList.map((sm) => {
      const updatedFields = sm.fields.map((field) => ({
        ...field,
        template_checked: false,
        field_required: false,
      }));
      return { ...sm, fields: updatedFields };
    });

    const updatedCommonPipeArray = commonPipeArray.map((field) => ({
      ...field,
      template_checked: false,
      field_required: false,
    }));

    setSubModuleList(updatedSubModuleList);
    setCommonPipeArray(updatedCommonPipeArray);
  };

  const openSaveTemplate = (copyFlag, selectedId, tempName) => {
    setSurveyTemplateModal(true);
    setIsCopy(copyFlag);
    setTemplateName(tempName);
    setEditTemplateId(selectedId);
  };
  const copySurveyTemplate = async (newTemplateName) => {
    try {
      if (customerId === null) {
        return;
      }
      setLoading(true)
      const getSurveyTemplateResponse = await getSurveyTemplate(
        customerId,
        getValues("isProClient")
      );
      const surveyTemplateData =
        getSurveyTemplateResponse?.data?.surveyTemplateData;
      const tempCheck = _.find(surveyTemplateData, {
        template_name: newTemplateName,
      });
      if (newTemplateName == "" || newTemplateName == undefined) {
        toastRef.current.showToast({
          type: "error",
          message: "Please enter Template name",
        });
      } else {
        if (_.isEmpty(tempCheck)) {
          const getSavedTemplateResponse = await getSavedTemplate(
            customerId,
            editTemplateId
          );
          const copyTemplateArray =
            getSavedTemplateResponse?.data?.savedTemplateData[0].sub_module.map(
              (element) => {
                var set = {
                  sub_module: {
                    sub_module_name: element.sub_module_name,
                    sub_module_id: subModuleId,
                    fields: {
                      id: element.fields.id,
                      label: element.fields.label,
                      type: element.fields.type,
                      field_index: element.fields.index,
                      field_status: element.fields.status,
                      template_checked: element.fields.checked,
                      reference_key: element.fields.reference_key,
                      field_key: element.fields.field_key,
                      validation: { message: element.fields.validation.message },
                    },
                  },
                };
                return set;
              }
            );
          const saveTemplateResponse = await saveTemplate(
            customerId,
            copyTemplateArray,
            newTemplateName,
            getValues("isProClient")
          );
          if (saveTemplateResponse && saveTemplateResponse.data.success) {
            toastRef.current.showToast({
              type: "success",
              message: "Template copied successfully",
            });
            setTimeout(() => {
              setSurveyTemplateModal(false);
            }, 300);
          } else {
            toastRef.current.showToast({
              type: "error",
              message: saveTemplateResponse.data.message,
            });
          }
        } else {
          toastRef.current.showToast({
            type: "error",
            message: "Template name already exists",
          });
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const removeTemplate = (selectedId, tempName) => {
    setShowConfirmPromptForTemplate(true);
    setRemoveTemplateId(selectedId);
    setRemoveTemplateName(tempName);
  };
  const removeSavedTemplates = async () => {
    try {
      setLoading(true)
      const removeSavedTemplateResponse = await removeSavedTemplate(
        removeTemplateId
      );
      if (removeSavedTemplateResponse && removeSavedTemplateResponse.data.success) {
        toastRef.current.showToast({
          type: "success",
          message: "Template Removed Successfully",
        });
        getSurveyTemplateFun();
        setTimeout(() => {
          setShowConfirmPromptForTemplate(false);
        }, 300);
      } else {
        toastRef.current.showToast({
          type: "error",
          message: "Error in removing Template",
        });
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const loadSurveyModel = () => {
    if (getValues("isProClient") !== undefined) {
      if (getValuesSurveyAddForm("subModuleIdSurvey")) {
        getFieldData(subModuleListDisplay[0]?.value);
      } else {
        getFieldData(subModuleListDisplay[0]?.value);
      }
      setSelectedEntity(null);
      setAddPipeLineFieldPopUp(true);
    } else {
      toastRef.current.showToast({
        type: "warn",
        message: "Please Select The Module",
      });
    }
  };

  const useTemplate = async () => {
    setTempShow(true);
    setAction(false);
    setEditTemplateId(useTempId);
    getFieldData(subModuleId);

    try {
      if (customerId === null) {
        return;
      }
      setLoading(true)
      const response = await getSavedTemplate(customerId, useTempId);
      const data = response?.data;
      const updatedCheckedListArray =
        data?.savedTemplateData[0]?.sub_module.map((element) => ({
          sub_module: {
            sub_module_name: element.sub_module_name,
            sub_module_id: subModuleId,
            fields: {
              id: element.fields.id,
              label: element.fields.label,
              type: element.fields.type,
              field_index: element.fields.index,
              field_status: element.fields.status,
              template_checked: element.fields.checked,
              reference_key: element.fields.reference_key,
              option_choice: element.fields?.option_choice,
              field_key: element.fields.field_key,
              validation: { message: element.fields.validation.message },
            },
          },
        }));

      setCheckedListArray(updatedCheckedListArray);
      setDefaults();
      getFieldData(subModuleId);
      setSurveyTemplateData((prevData) =>
        prevData.map((element) => ({
          ...element,
          template_checked: false,
        }))
      );
      setUseTemp(false);
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  // Function to call the API and update the template
  const updateTemplate = async (tmpField) => {
    try {
      setLoading(true)
      const response = await updateSurveyTemplate(
        editTemplateId,
        checkedListArray,
        templateName
      );
      const data = response?.data;
      if (data && data.success) {
        toastRef.current.showToast({
          type: "success",
          message: "Template updated successfully",
        });
        getSurveyTemplate(); // Function to fetch the updated survey templates
        // Close the modal (ensure you have a method to handle this)
        setEditSurveyTemplateModal(false);
        setAction(false);
        setDefaults();
        setCheckedListArray([]);
      } else {
        toastRef.current.showToast({
          type: "error",
          message: data.message,
        });
      }
    } catch (error) {
      toastRef.current.showToast({
        type: "error",
        message: "An error occurred while updating the template",
      });
    } finally {
      setLoading(false)
    }
  };

  const saveTemplateData = async (tempName, checkedListArray) => {
    setErrorFlag(false);

    try {
      setLoading(true)
      const enduserStr = localStorage.getItem("enduser");
      if (enduserStr) {
        const enduser = JSON.parse(enduserStr);
        const customer = enduser.customer;
        const data = await getSurveyTemplate(customer, tempName); // replace with your actual service call
        setSurveyTemplateData(data?.data?.surveyTemplateData);
        const tempCheck = data?.data?.surveyTemplateData.find(
          (template) => template.template_name === tempName
        );

        if (!tempName) {
          setErrorFlag(true);
          toastRef.current.showToast({
            type: "error",
            message: "Please enter template name",
          });
        } else if (!tempCheck) {
          setErrorFlag(false);
          const saveData = await saveTemplate(
            customer,
            checkedListArray,
            tempName,
            getValues("isProClient")
          ); // replace with your actual service call
          if (saveData && saveData.data.success) {
            setErrorFlag(false);
            toastRef.current.showToast({
              type: "success",
              message: `${tempName} saved successfully`,
            });

            getSurveyTemplate();
            setTimeout(() => {
              setSurveyTemplateModal(false);
            }, 300);
          } else {
            toastRef.current.showToast({
              type: "error",
              message: saveData.message,
            });
          }
        } else {
          setErrorFlag(true);
          toastRef.current.showToast({
            type: "error",
            message: `${tempName} name already exists`,
          });
        }
      } else {
        navigate("/login")
        localStorage.clear()
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const nameValidation = (val) => {
    if (val === undefined || val === "") {
      setErrorFlag(true);
    } else {
      setErrorFlag(false);
    }
  };

  const onRowClick = (data) => {
    setSelectedRowData(data);
  };

  useEffect(() => { }, [checkedListArray]);
  const rowClick = () => { };
  const publishSurvey = () => {
    if (
      getValues("surveyName") &&
      getValues("isProClient") &&
      getValues("surveyName") &&
      getValues("users")?.external_email
    ) {
      var fieldsCheckedCount = 0;
      checkedListArray.forEach((i) => {
        if (i.sub_module.fields.validation.message == "Yes") {
          fieldsCheckedCount++;
        }
      });
      if (fieldsCheckedCount > 0) {
        setPublishsurveyPopup(true);
      } else {
        toastRef.current.showToast({
          type: "error",
          message: "Please select atleast one mandatory field",
        });
      }
    } else {
      toastRef.current.showToast({
        type: "error",
        message: "Survey Name, External Email, Projects(s) are invalid",
      });
    }
  };

  const clearPipelineFields = () => {
    setCheckedListArray([]);
  };
  const getCollectionTemplate = (data) => {
    if (data) {
      setUseTempId(data[data.length - 1]?._id);
    }
  };
  const [getExternalUserName, setGetExternalUserName] = useState("");
  const [externalUserDetails, setExternalUserDetails] = useState(null);
  const [adminNotes, setAdminNotes] = useState("");
  const handleGetExternameUser = async (val) => {
    try {
      if (customerId === null) {
        return;
      }
      // setLoading(true)
      const externameUserResponse = await getExternalUsersName(
        customerId,
        val.external_email
      );
      if (externameUserResponse && externameUserResponse.status == 200) {
        setGetExternalUserName(
          externameUserResponse?.data.users[0]?.external_user_name
        );
        setExternalUserDetails(externameUserResponse?.data.users[0]);
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };
  const sendSurveyMail = async () => {
    var SurveyToolResponse = {};
    try {
      setLoading(true)
      const admindataResponse = await getuserbyid(Customer.userid);
      const admindata = {
        user_email: admindataResponse?.data?.email,
        user_id: admindataResponse?.data?._id,
        user_name:
          admindataResponse?.data?.firstname + "" + admindataResponse?.data?.surname,
      };
      const surveyForm = {
        survey_name: getValues("surveyName"),
        remainderUser: [
          { label: "1 hour", value: 1 },
          { label: "3 days", value: 2 },
          { label: "5 Days", value: 3 },
          { label: "15 Days", value: 4 },
          { label: "1 Month", value: 5 },
        ].find((item) => item.value === surveyConfigForm?.remaindUser)?.label,
        isRemainder: surveyConfigForm.remaindar,
        isProClient: getValues("isProClient"),
        opportunityListSurvey: surveyConfigForm.projectList,
        clientListSurvey: surveyConfigForm.clientList,
        users: externalUserDetails,
        adminNotes: adminNotes,
      };
      let sendSurveyData = {
        adminDetails: admindata,
        surveyForm: surveyForm,
        fieldsArray: [],
        tableArray: [],
        tableArrayStatus: false,
        targetArray: [],
        targetArrayStatus: false,
        widgetArray: [],
        widgetArrayStatus: false,
        knownStackStatus: false,
        customer_id: customerId,
      };
      checkedListArray.forEach((element) => {
        var getSubModuleFieldData = _.find(
          subModuleList,
          { sub_module_name: "Relationship Development Score" },
          true
        )?.fields;
        var exactData = _.find(
          getSubModuleFieldData,
          { _id: element.sub_module.fields.id },
          true
        );

        element.sub_module.fields["group"] = exactData?.group;
        element.sub_module.fields["flag_status"] =
            element.sub_module.fields["flag_status"] &&
            element.sub_module.fields["flag_status"] !== "false"
                ? element.sub_module.fields["flag_status"]
                : Boolean(exactData?.flag_status);
        if (
          element.sub_module.fields.type == "table" ||
          element.sub_module.fields.type == "Table"
        ) {
          if (element.sub_module.sub_module_name == "Targets") {
            sendSurveyData.targetArray.push(element);
            sendSurveyData.targetArrayStatus = true;
          } else if (
            element.sub_module.sub_module_name == "Submission Management"
          ) {
            sendSurveyData.targetArray.push(element);
            sendSurveyData.tableArrayStatus = true;
          } else {
            sendSurveyData.tableArray.push(element);
            sendSurveyData.knownStackStatus = true;
          }
        } else if (element.sub_module.fields.type == "widget") {
          if (element.sub_module.fields.field_key == "Document Reference") {
            sendSurveyData.documentReference = true;
          } else if (element.sub_module.fields.field_key == "Client Key Issues") {
            sendSurveyData.clientKeyIssues = true;
          } else if (element.sub_module.fields.field_key == "Client Objectives") {
            sendSurveyData.clientObjectives = true;
          } else if (element.sub_module.fields.field_key == "Client Needs") {
            sendSurveyData.clientNeeds = true;
          } else {
          }
          sendSurveyData.widgetArray.push(element);
          sendSurveyData.widgetArrayStatus = true;
        } else {
          sendSurveyData.fieldsArray.push(element);
        }
      });
      const sendSurveyEmailResponse = await addsurveydata(sendSurveyData);
      if (sendSurveyEmailResponse.data) {
        SurveyToolResponse.customer_id = customerId;
        SurveyToolResponse.user_id =
          sendSurveyEmailResponse.data.surveyData.surveyData.userId;
        SurveyToolResponse.user_email =
          sendSurveyEmailResponse.data.surveyData.surveyData.userEmail;
        SurveyToolResponse.survey_name =
          sendSurveyEmailResponse.data.surveyData.surveyData.survey_name;
        SurveyToolResponse.survey_form_id =
          sendSurveyEmailResponse.data.surveyData.surveyData._id;
        SurveyToolResponse.remaind_user =
          sendSurveyEmailResponse.data.surveyData.surveyData.remaindUser;
        SurveyToolResponse.admin_user_id =
          sendSurveyEmailResponse.data.surveyData.surveyData.admin_user_id;
        SurveyToolResponse.admin_user_name =
          sendSurveyEmailResponse.data.surveyData.surveyData.admin_user_name;
        SurveyToolResponse.status = "inComplete";
        SurveyToolResponse.user_name =
          sendSurveyEmailResponse.data.surveyData.surveyData.userName;
        SurveyToolResponse.adminNotes = adminNotes;
        const saveSurveyLogsResponse = await saveSurveyLogs(
          SurveyToolResponse,
          sendSurveyEmailResponse.data.surveyData.surveyData._id
        );
        if (saveSurveyLogsResponse && saveSurveyLogsResponse.data.success) {
          toastRef.current.showToast({
            type: "success",
            message: "Survey Send Successfully",
          });
          setTimeout(() => {
            setPublishsurveyPopup(false);
          }, 300);
        } else {
          toastRef.current.showToast({
            type: "error",
            message: "Survey not sent",
          });
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      setLoading(false)
    }
  };

  const renderFooter = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            type="submit"
            label="Ok"
            className="save-button"
            onClick={() => setAddPipeLineFieldPopUp(false)}
          />
        </div>
      </div>
    );
  };

  const renderFooter1 = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            type="submit"
            label="Update"
            className="save-button"
            onClick={() => updateTemplate(tmpField)}
          />
        </div>
      </div>
    );
  };

  const renderFooter2 = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            label="Cancel"
            className="cancel-new-button"
            onClick={() => {
              if (!viewSurveyTemplateModal) return;
              setViewSurveyTemplateModal(false);
            }}
          />
        </div>
      </div>
    );
  };

  const renderFooter3 = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            type="submit"
            label={!isCopy ? "Save" : "Save Copy"}
            className="save-button"
            onClick={() =>
              !isCopy
                ? saveTemplateData(getValues("templateName"), checkedListArray)
                : copySurveyTemplate(getValues("templateName"))
            }
          />
        </div>
      </div>
    );
  };

  const renderFooter4 = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            type="submit"
            label="Ok"
            className="save-button"
            onClick={() => removeSavedTemplates()}
          />
        </div>
      </div>
    );
  };

  const renderFooter5 = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            type="submit"
            label="Add"
            className="save-button"
            onClick={handleSubmitExternalEmail}
          />
        </div>
      </div>
    );
  };

  const renderFooterPublish = () => {
    return (
      <div className="cancel-footer">
        <div className="align-center justify-end pb-0">
          <ButtonElement
            type="submit"
            label="Confirm"
            className="save-button"
            onClick={sendSurveyMail}
          />
        </div>
      </div>
    );
  };
  const [chooseModuleName, setChooseModuleName] = useState("")
  const [chooseModuleName1, setChooseModuleName1] = useState("")
 
  useEffect(()=>{
    if(customerField && customerField?.modules){
      const projectName = customerField?.modules?.find((item) => item.module_name === "Pipeline").display_name ||""
      const stakeholderName = customerField?.modules &&
        customerField?.modules.find(
          (item) => item.module_name === "Clients"
        ).display_name ||
      ""
      setChooseModuleName(projectName)
      setChooseModuleName1(stakeholderName)
    }
  },[customerField])

  useEffect(() => {
    if(chooseModuleName && loading) {
      setLoading(false)
    }
  }, [chooseModuleName])

  const handleButtonClick = () => {
      setShowVideo(true);
  };

  const closeVideo = () => {
      setShowVideo(false);
  };

  return (
    <div className="mt-20">
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <div className="new-field">
        <div>
          <p className="fs-16 fw-600 mar-b-3">
          {customerControlFields?.display_name}
          </p>
          <div className="col-md-12 text-right">
          <ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
          </div>
        </div>
        <p className="group-table-text-section">
          Use this section to add survey
        </p>
        <form onSubmit={handleSubmit(onSurveyFormSubmit)}>
          <div className="form-group row align-items-center mb-0 mt-0 width-50">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left">
                {customerControlFields?.tables[0]?.headers[6]?.display_name}:
              </label>
            </div>
            <div className="col pr-0">
              <InputTextElement
                id="surveyName"
                onChange={(e) => {
                  setValue("surveyName", e.target.value);
                  trigger("surveyName");
                }}
                required
                maxLength="50"
                className="w-full"
                placeholder="Data Collection Name"
                autocomplete="off"
                register={register("surveyName", {
                  required: "Data Collection Name is required",
                })}
              />
              {errors.surveyName && (
                <small className="text-danger">
                  {errors.surveyName.message}
                </small>
              )}
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0 width-50">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left">
                {customerControlFields?.tables[0]?.headers[7]?.display_name}:
              </label>
            </div>
            <div className="col">
              <AutoCompleteElement
                id="users"
                value={getValues("users")}
                onChangeValue={(e) => {
                  handleGetExternameUser(e.value);
                  setValue("users", e.value);
                  trigger("users");
                }}
                placeholder="Select Mail"
                autocomplete="off"
                items={extUsers}
                register={register("users", {
                  required: "User Mail is required",
                })}
                setValue={setValue}
                className="w-full"
              />
              {errors.users && (
                <small className="text-danger">{errors.users.message}</small>
              )}
            </div>
            <div className="col-md-2 pr-0">
              <ButtonElement
                className="save-button-add"
                type="button"
                label="Add"
                onClick={(event) => {
                  event.preventDefault();
                  setAddExtraEmailPopUp(true);
                }}
              />
            </div>
          </div>
          <div className="form-group row align-items-center mb-0 mt-0 width-50">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left">
                {customerControlFields?.tables[0]?.headers[8]?.display_name}:
              </label>
            </div>
            <div className="col pr-0">
              <SelectButtonElement
                id="isProClient"
                options={[
                  {
                    label:chooseModuleName,
                    value: "Project",
                  },
                  {
                    label:chooseModuleName1,
                    value: "Client",
                  },
                ]}
                value={getValues("isProClient")}
                onChangeSelect={(e) => {
                  setValue("isProClient", e.value);
                  trigger("isProClient");
                  clearEditSurveyToggle(getValues("isProClient"));
                }}
                register={register("isProClient", {
                  required: "Module is required",
                })}
                setValue={setValue}
              />
              {errors.isProClient && (
                <small className="text-danger">
                  {errors.isProClient.message}
                </small>
              )}
            </div>
          </div>
          {getValues("isProClient") === "Project" && (
            <div className="form-group row align-items-center mb-0 mt-0 width-50">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {customerField?.modules &&
                    customerField?.modules.find(
                      (item) => item.module_name === "Pipeline"
                    ).display_name}
                  (s):
                </label>
              </div>
              <div className="col pr-0">
                <MultiSelectElement
                  id="projectList"
                  name="project_list"
                  value={getValues("projectList")}
                  onChangeValue={(e) => {
                    handleSurveyConfigForm(e);
                    setValue("projectList", e.value);
                    trigger("projectList");
                  }}
                  options={getCusOpportunity}
                  placeholder="-- Please select --"
                  maxSelectedLabels={1}
                  className="w-full"
                  register={register("projectList", {
                    required: "Project List is required",
                  })}
                />
                {errors.projectList && (
                  <small className="text-danger">
                    {errors.projectList.message}
                  </small>
                )}
              </div>
            </div>
          )}
          {getValues("isProClient") === "Client" && (
            <div className="form-group row align-items-center mb-0 mt-0 width-50">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {customerField?.modules &&
                    customerField?.modules.find(
                      (item) => item.module_name === "Clients"
                    ).display_name}
                  (s):
                </label>
              </div>
              <div className="col pr-0">
                <MultiSelectElement
                  id="clientList"
                  name="client_list"
                  value={getValues("clientList")}
                  onChangeValue={(e) => {
                    handleSurveyConfigForm(e);
                    setValue("clientList", e.value);
                    trigger("clientList");
                  }}
                  optionLabel="label"
                  options={clientList}
                  placeholder="-- Please select --"
                  maxSelectedLabels={1}
                  className="w-full"
                  register={register("clientList", {
                    required: "Client List is required",
                  })}
                />
                {errors.clientList && (
                  <small className="text-danger">
                    {errors.clientList.message}
                  </small>
                )}
              </div>
            </div>
          )}
          <div className="form-group row align-items-center mb-0 mt-0 width-50">
            <div className="col-md-4 pl-0">
              <label className="form-label text-left">
                {customerControlFields?.tables[0]?.headers[9]?.display_name}:
              </label>
            </div>
            <div className="col pr-0">
              <RadioElement
                id="remaindar"
                options={[
                  { key: "Yes", name: "Yes" },
                  { key: "No", name: "No" },
                ]}
                value={surveyConfigForm.remaindar}
                onChangeRadio={handleSurveyConfigForm}
                className="radio-group-class" // Add any additional classes if necessary
              />
            </div>
          </div>
          {surveyConfigForm.remaindar === "Yes" && (
            <div className="form-group row align-items-center mb-0 mt-0 width-50">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">Remind User:</label>
              </div>
              <div className="col pr-0">
                <SingleSelectElement
                  id="remaindUser"
                  name="remaindUser"
                  options={[
                    { label: "1 hour", value: 1 },
                    { label: "3 days", value: 2 },
                    { label: "5 Days", value: 3 },
                    { label: "15 Days", value: 4 },
                    { label: "1 Month", value: 5 },
                  ]}
                  value={surveyConfigForm.remaindUser}
                  onChangeValue={handleSurveyConfigForm}
                  register={register("remaindUser", { required: false })}
                  placeholder="-- Please select --"
                  maxSelectedLabels={1}
                  optionLabel="label"
                  className="w-full"
                />
              </div>
            </div>
          )}

          <Dialog
            header="Publish Data Collection"
            visible={publishsurveyPopup}
            position="right"
            className="width-42"
            onHide={() => {
              if (!publishsurveyPopup) return;
              setPublishsurveyPopup(false);
            }}
            draggable={false}
            resizable={false}
            footer={renderFooterPublish()}
          >
            <div className="new-field">
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-4 pl-0">
                  <label className="form-label text-left">
                    {customerControlFields?.tables[0]?.headers[6]?.display_name}
                    :
                  </label>
                </div>
                <div className="col pr-0">
                  <label className="form-label text-left">
                    {getValues("surveyName")}
                  </label>
                </div>
              </div>
              {getValues("isProClient") == "Client" && (
                <div className="form-group row align-items-center mb-0 mt-0">
                  <div className="col-md-4 pl-0">
                    <label className="form-label text-left">
                      Stakeholder(s):
                    </label>
                  </div>
                  <div className="col pr-0">
                    {getValues("clientList")?.length > 0 &&
                      getValues("clientList")?.map((list) => {
                        return (
                          <li>
                            <label className="form-label text-left">
                              {list.label}&nbsp;&nbsp;&nbsp;
                            </label>
                          </li>
                        );
                      })}
                    {/* {surveyConfigForm.clientList?.map((field) =>
                      surveyFormData?.clientList?.length == 1 ? (
                        <>
                          <div className="flex direction-col">
                            <label className="form-label text-left">
                              {field.label}
                            </label>
                          </div>
                        </>
                      ) : surveyFormData?.clientList?.length > 1 ? (
                        <li>
                          <label className="form-label text-left">
                            {field.label}
                          </label>
                        </li>
                      ) : null
                    )} */}
                  </div>
                </div>
              )}
              {getValues("isProClient") == "Project" && (
                <div className="form-group row align-items-center mb-0 mt-0">
                  <div className="col-md-4 pl-0">
                    <label className="form-label text-left">Project(s):</label>
                  </div>
                  <div className="col pr-0">
                    {getValues("projectList")?.length > 0 &&
                      getValues("projectList")?.map((list) => {
                        return (
                          <li>
                            <label className="form-label text-left">
                              {list.label}&nbsp;&nbsp;&nbsp;
                            </label>
                          </li>
                        );
                      })}
                    {/* {surveyConfigForm.projectList?.map((field) =>
                      surveyConfigForm.projectList.length == 1 ? (
                        <>
                          <div className="flex direction-col">
                            <label className="form-label text-left">
                              {field.label}
                            </label>
                          </div>
                        </>
                      ) : surveyConfigForm.projectList.length > 1 ? (
                        <li>
                          <label className="form-label text-left">
                            {field.label}
                          </label>
                        </li>
                      ) : null
                    )} */}
                  </div>
                </div>
              )}
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-4 pl-0">
                  <label className="form-label text-left">External User:</label>
                </div>
                <div className="col pr-0">
                  <label className="form-label text-left">
                    {getExternalUserName}
                  </label>
                </div>
              </div>
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-4 pl-0">
                  <label className="form-label text-left">
                    {customerControlFields?.tables[0]?.headers[7]?.display_name}
                    :
                  </label>
                </div>
                <div className="col pr-0">
                  <label className="form-label text-left">
                    {getValues("users")?.external_email}
                  </label>
                </div>
              </div>
              {surveyConfigForm?.remaindar == "Yes" && (
                <div className="form-group row align-items-center mb-0 mt-0">
                  <div className="col-md-4 pl-0">
                    <label className="form-label text-left">Remind User:</label>
                  </div>
                  <div className="col pr-0">
                    <label className="form-label text-left">
                      {
                        [
                          { label: "1 hour", value: 1 },
                          { label: "3 days", value: 2 },
                          { label: "5 Days", value: 3 },
                          { label: "15 Days", value: 4 },
                          { label: "1 Month", value: 5 },
                        ].find(
                          (item) => item.value === surveyConfigForm.remaindUser
                        )?.label
                      }
                    </label>
                  </div>
                </div>
              )}
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-4 pl-0">
                  <label className="form-label text-left">Admin Note(s):</label>
                </div>
                <div className="col pr-0">
                  <TextareaElement
                    placeholder="Admin Note"
                    onChange={(e) => setAdminNotes(e.target.value)}
                    rows={5}
                  ></TextareaElement>
                </div>
              </div>
              <div className="mt-10">
                <DataTable
                  key={tableKey}
                  value={checkedListArray}
                  columns={pipelineFieldsColumns}
                  ref={childRef}
                  isNewField={true}
                  rowClick={(data) => onRowClick(data)}
                  dataKey="sub_module.fields.id"
                />
              </div>
            </div>
          </Dialog>
          {/* Datatables */}

          {/* Pipeline Fields */}
          <div className="form-group row align-items-center mt-30">
            <div className="col-md-4 pl-0 pt-17">
              <p className="label-text">
                {customerControlFields?.tables[0]?.display_name}
              </p>
            </div>
            <div className="col pr-0 d-flex justify-end">
              <ButtonElement
                className="edit-option-button"
                type="button"
                icon="pi pi-times"
                onClick={clearPipelineFields}
              />
              <ButtonElement
                className="edit-option-button ml-10"
                type="button"
                icon="pi pi-trash"
                onClick={handleClick}
              />
              <ButtonElement
                className="edit-option-button ml-10"
                type="button"
                icon="pi pi-plus"
                onClick={loadSurveyModel}
              />
            </div>
          </div>
          <div className="mt-20">
            <DataTable
              key={tableKey}
              value={checkedListArray}
              columns={pipelineFieldsColumns}
              ref={childRef}
              isNotReorder={true}
              rowClick={(data) => onRowClick(data)}
              dataKey="sub_module.fields.id"
            />
          </div>
          <div className="cancel-footer mt-20">
            <div className="align-center justify-end pb-0 d-flex">
              <ButtonElement
                label="Save as Template"
                className="cancel-new-button"
                onClick={() => {
                  setSurveyTemplateModal(true);
                }}
              />
              <ButtonElement
                type="submit"
                label="Publish"
                className="save-button"
                onClick={publishSurvey}
              />
            </div>
          </div>

          {/* Data Collection Templates */}
          <div className="form-group row align-items-center mt-30">
            <div className="col-md-4 pl-0 pt-17">
              <p className="label-text">
                {customerControlFields?.tables[1]?.display_name}
              </p>
            </div>
          </div>
          <div className="mt-20">
            <DataTable
              value={surveyTemplateData}
              columns={surveyTemplateDataFieldsColumns}
              removeField={removeSurveyTemplateField}
              getCollectionTemplate={(data) => getCollectionTemplate(data)}
              isDataCollectionTemplates={true}
              isNotReorder={true}
              dataKey="_id"
            />
          </div>
          <div className="cancel-footer mt-20">
            <div className="align-center justify-end pb-0 d-flex">
              <ButtonElement
                type="submit"
                label="Use Template"
                className="save-button"
                onClick={useTemplate}
              />
            </div>
          </div>

          {/* Modal Starts */}
          {/* Add pipeline fields */}
          <Dialog
            header={`Add ${customerControlFields?.tables[0]?.display_name}`}
            visible={addPipeLineFieldPopUp}
            position="right"
            className="width-42"
            onHide={() => {
              if (!addPipeLineFieldPopUp) return;
              setAddPipeLineFieldPopUp(false);
            }}
            draggable={false}
            resizable={false}
            footer={renderFooter()}
          >
            <div className="new-field">
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-2 pl-0">
                  <label className="form-label text-left">
                    {customerControlFields?.tables[0]?.headers[2]?.display_name}
                  </label>
                </div>
                <div className="col pr-0">
                  <SingleSelectElement
                    id="subModuleIdSurvey"
                    name="subModuleIdSurvey"
                    options={(subModuleListDisplay != undefined && subModuleListDisplay.length > 0) ? subModuleListDisplay : []}
                    optionLabel="label"
                    value={subModuleListDisplay[0]?.value}
                    onChangeSelect={(e) => handleSurveyConfigForm(e)}
                    onChangeValue={(e) => {
                      setValueSurveyAddForm(
                        "subModuleIdSurvey",
                        e.target.value
                      );
                      setSubModuleId(e.target.value);
                      getFieldData(e.target.value);
                      triggerSurveyAddForm("subModuleIdSurvey");
                    }}
                    register={registerSurveyAddForm("subModuleIdSurvey", {
                      required: "SubModule Id Survey is required",
                    })}
                    placeholder="-- Please select --"
                    maxSelectedLabels={1}
                    className="w-full"
                  />
                  {errorsSurveyAddForm.subModuleIdSurvey && (
                    <small className="text-danger">
                      {errorsSurveyAddForm.subModuleIdSurvey.message}
                    </small>
                  )}
                </div>
              </div>
              <div className="mt-10">
                <DataTable
                  key={subModuleId}
                  value={tmpField}
                  columns={templatesFieldsColumns}
                  // selectedRow={tmpField.filter((item) => item.template_checked)}
                  removeField={removeSurveyTemplateField}
                  // rowClick={rowClick}
                  isDataCollectionConfig={true}
                  dataKey="_id"
                />
              </div>
            </div>
          </Dialog>

          {/* Edit Template*/}
          <Dialog
            header={action ? "Edit Data Collection fields" : templateName}
            visible={editSurveyTemplateModal}
            position="right"
            className="width-42"
            onHide={() => {
              // clearEditSurvey();
              setSubModuleId(subModuleListDisplay[0]?.value)
              getFieldData(subModuleListDisplay[0]?.value)
              if (!editSurveyTemplateModal) return;
              setEditSurveyTemplateModal(false);
            }}
            draggable={false}
            resizable={false}
            footer={renderFooter1()}
          >
            <div className="new-field">
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-2 pl-0">
                  <label className="form-label text-left">
                    {customerControlFields?.tables[0]?.headers[2]?.display_name}
                  </label>
                </div>
                <div className="col pr-0">
                  <SingleSelectElement
                    id="subModuleIdSurveyEdit"
                    name="subModuleIdSurveyEdit"
                    options={(subModuleListDisplay != undefined && subModuleListDisplay.length > 0) ? subModuleListDisplay : []}
                    optionLabel="label"
                    value={subModuleListDisplay[0]?.value}
                    onChangeSelect={(e) => handleSurveyConfigForm(e)}
                    onChangeValue={(e) => {
                      setValueSurveyAddForm(
                        "subModuleIdSurveyEdit",
                        e.target.value
                      );
                      setSubModuleId(e.target.value);
                      getFieldData(e.target.value);
                      triggerSurveyAddForm("subModuleIdSurveyEdit");
                    }}
                    register={registerSurveyAddForm("subModuleIdSurveyEdit", {
                      required: "SubModule Id Survey is required",
                    })}
                    placeholder="-- Please select --"
                    maxSelectedLabels={1}
                    className="w-full"
                  />
                  {errorsSurveyAddForm.subModuleIdSurvey && (
                    <small className="text-danger">
                      {errorsSurveyAddForm.subModuleIdSurvey.message}
                    </small>
                  )}
                </div>
              </div>
              <div className="mt-10">
                <DataTable
                  key={subModuleId}
                  value={tmpField}
                  columns={templatesFieldsColumns}
                  selectedRow={tmpField.filter((item) => item.template_checked)}
                  removeField={removeSurveyTemplateField}
                  rowClick={rowClick}
                  isDataCollectionConfig={true}
                />
              </div>
            </div>
          </Dialog>

          {/* View Template */}
          <Dialog
            header={templateNameView}
            visible={viewSurveyTemplateModal}
            position="right"
            className="width-42"
            onHide={() => {
              if (!viewSurveyTemplateModal) return;
              setViewSurveyTemplateModal(false);
            }}
            draggable={false}
            resizable={false}
            footer={renderFooter2()}
          >
            <div className="new-field">
              <div className="mt-10">
                <DataTable
                  value={viewSurveyFields}
                  columns={viewSurveyFieldsColumns}
                  isNewField={true}
                />
              </div>
            </div>
          </Dialog>

          {/* Save Template */}
          <Dialog
            visible={surveyTemplateModal}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Save Template"
            modal
            footer={renderFooter3()}
            onHide={() => {
              if (!surveyTemplateModal) return;
              setSurveyTemplateModal(false);
            }}
            className="table-dialog width-32"
            draggable={false}
          >
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  Template Name:
                </label>
              </div>
              <div className="col pr-0">
                <InputTextElement
                  id="templateName"
                  className=".p-inputtext-lg to enlarge it"
                  onChange={(e) => {
                    setValue("templateName", e.target.value);
                    trigger("templateName");
                    nameValidation(getValues(e.target.value));
                  }}
                  maxLength="50"
                  placeholder=""
                  autocomplete="off"
                  register={register("templateName", {
                    required: "Template Name is required",
                  })}
                />
              </div>
            </div>
          </Dialog>

          {/* Remove template*/}
          <Dialog
            visible={showConfirmPromptForTemplate}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm Delete"
            modal
            footer={renderFooter4()}
            onHide={() => {
              if (!showConfirmPromptForTemplate) return;
              setShowConfirmPromptForTemplate(false);
            }}
            className="table-dialog width-32"
            draggable={false}
          >
            <div className="confirmation-content">
              <span className="table-description">
                Do you want to delete <b>{removeTemplateName}</b> ?
              </span>
            </div>
          </Dialog>

          {/* Add External Email */}
          <Dialog
            header="Add External Email"
            visible={addExtraEmailPopUp}
            position="right"
            className="width-32"
            onHide={() => {
              if (!addExtraEmailPopUp) return;
              setAddExtraEmailPopUp(false);
              setFormData({});
              setDialogError({
                external_email: "",
                external_user_name: ""

              })

            }}
            draggable={false}
            resizable={false}
            footer={renderFooter5()}
          >
            <div>
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-3 pl-0">
                  <label className="form-label text-left">User Name:</label>
                </div>
                <div className="col pr-0">
                  <InputTextElement
                    id="external_user_name"
                    className="w-full"
                    value={formData?.external_user_name}
                    onChange={(e) => handleInputChange("external_user_name", e.target.value)}
                    maxLength="50"
                    placeholder="Text"
                    autocomplete="off"
                  />
                  {dialogError.external_user_name && (
                    <small className="text-danger">
                      {dialogError.external_user_name}
                    </small>
                  )}
                </div>
              </div>
              <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col-md-3 pl-0">
                  <label className="form-label text-left">User Email:</label>
                </div>
                <div className="col pr-0">
                  <InputTextElement
                    type="email"
                    id="external_email"
                    className="w-full"
                    value={formData?.external_email}
                    onChange={(e) => handleInputChange("external_email", e.target.value)}
                    maxLength="50"
                    placeholder="Email"
                    autocomplete="off"
                  />
                  {dialogError.external_email && (
                    <small className="text-danger">
                      {dialogError.external_email}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </Dialog>
          <Dialog id="videoModal" visible={showVideo}
              breakpoints={{
                  '1200px': '80vw',    // Larger modal on bigger screens
                  '1024px': '85vw',    // Slightly smaller for medium screens
                  '769': '90vw',     // Responsive on tablets
                  '641px': '95vw',     // Almost full-width on mobile
              }}
              modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
          >
              <div className="video-overlay">
                  <div className="video-container">
                      <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_data_collection" />
                  </div>
              </div>
          </Dialog>
        </form>
      </div>
    </div>
  );
}
